/**
 * Consentimento de cookies (web). Só marketing (Meta Pixel) depende dele;
 * cookies essenciais (sessão, atribuição first-party) não.
 */

export type CookieConsent = 'accepted' | 'rejected';

const STORAGE_KEY = 'controlapag_cookie_consent';

export function getCookieConsent(): CookieConsent | null {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  } catch {
    return null;
  }
}

export function setCookieConsent(value: CookieConsent): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // storage bloqueado: banner volta na próxima visita
  }
}
